import React from 'react';
import './caremanagement.scss';


const ResourceDropdown = ({ isOpen, onClose, history, movetoContact }) => {

    const ResourceManagementSections = [
        {
            title: 'Learn',
            items: [
                {
                    icon: 'reading-book.png',
                    title: 'Help Centre',
                    description: 'Guides and tutorials',
                    route: '/help-centre'
                },
                {
                    icon: 'presentation.png',
                    title: 'Training',
                    description: 'Online courses & webinars',
                    route: '/training'
                },
                {
                    icon: 'working.png',
                    title: 'Blog',
                    description: 'Industry insights & tips',
                    route: '/blog'
                },
            ]
        },
        {
            title: 'Support',
            items: [
                {
                    icon: 'chat.png',
                    title: 'Contact Support',
                    description: 'Get help from our team',
                    route: '/contact-us'
                },
                {
                    icon: 'setting.png',
                    title: 'System Status',
                    description: 'Check service uptime',
                    route: '/system-status'
                },
                {
                    icon: 'mobile-phone.png',
                    title: 'Product Tours',
                    description: 'Self-guided walkthroughs',
                    route: '/product-tours'
                },
            ]
        },
    ];

    const handleItemClick = (route) => {
        window.scrollTo(0, 0);
        if (route === '/blog') {
            window.location.href = 'https://www.caredaily.co.uk/blog';
        } else {
            history.push(route);
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div
            className="care-management-dropdown-overlay"
            onClick={(e) => e.stopPropagation()} onMouseLeave={onClose}
        >
            <div className="care-management-sections-wrapper-resource" onMouseLeave={onClose}>
                {ResourceManagementSections.map((section, sectionIndex) => (
                    <div key={sectionIndex} className="care-management-section">
                        <h4 className="care-management-section-title">{section.title}</h4>
                        <div className="care-management-section-items">
                            {section.items.map((item, itemIndex) => (
                                <div
                                    key={itemIndex}
                                    className="care-management-item"
                                    onClick={() => handleItemClick(item.route)}
                                >
                                    <div className="care-management-item-icon">
                                        <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/${item.icon}`} alt={item.title} width="24px" />
                                    </div>
                                    <div className="care-management-item-content">
                                        <h4>{item.title}</h4>
                                        <p>{item.description}</p>
                                    </div>
                                    <div className="care-management-item-arrow">
                                        →
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* //   <div className="care-management-dropdown-footer">
        //     <button
        //        className="care-management-contact-btn"
        //        onClick={() => {
        //           movetoContact && movetoContact();
        //           onClose();
        //        }}
        //     >
        //        Need Help? Contact Us
        //     </button>
        //  </div>  */}
        </div>
    );
};

export default ResourceDropdown;